module.exports = __webpack_public_path__ + "img/rectangular-brown-wooden-dining-table-and-wooden-chairs-3229076.7c23b55f.jpg";